import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/Section";
import CategoryGrid from "@/components/CategoryGrid";
import { Reveal } from "@/components/Reveal";

export default function Categories() {
  return (
    <section data-testid="product-categories" className="py-24 md:py-32 bg-white border-y border-forest/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <SectionHeading
            chapter="02 / One-Stop Shop"
            overline="Everything Your Restaurant Needs"
            title={<>Everything your restaurant needs, all in one place</>}
            lead="More than 500 SKUs available from one convenient wholesale location — organized into the categories your kitchen orders from every week."
          />
          <Reveal delay={0.1}>
            <Link
              to="/product-categories"
              data-testid="view-all-categories-btn"
              className="group inline-flex items-center gap-2 rounded-full bg-forest text-butter px-6 py-3 text-sm font-semibold hover:bg-forest-deep transition-colors duration-300 whitespace-nowrap"
            >
              View All Product Categories
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
        <CategoryGrid />
      </div>
    </section>
  );
}
